import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-497507d0"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "DutyCheckViewContainer"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "打卡统计", -1));
const _hoisted_3 = {
  key: 0
};
const _hoisted_4 = {
  class: "bothCenter"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_svg_icon = _resolveComponent("svg-icon");
  const _component_el_row = _resolveComponent("el-row");
  const _component_el_image = _resolveComponent("el-image");
  const _component_BatterTableDataView = _resolveComponent("BatterTableDataView");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_row, {
    class: "crumbs"
  }, {
    default: _withCtx(() => [_createVNode(_component_svg_icon, {
      "icon-class": "house"
    }), _hoisted_2]),
    _: 1
  }), _createVNode(_component_el_row, {
    style: {
      "width": "100%"
    }
  }, {
    default: _withCtx(() => [_createVNode(_component_BatterTableDataView, {
      "table-id": "25",
      "export-btn": ""
    }, {
      total: _withCtx(data => [_createElementVNode("span", null, _toDisplayString(data.data.normal) + "/" + _toDisplayString(data.data.total), 1)]),
      images: _withCtx(data => [!data.rowData || data.rowData.length < 1 ? (_openBlock(), _createElementBlock("span", _hoisted_3, "无")) : (_openBlock(), _createBlock(_component_el_row, {
        key: 1,
        class: "leftCenter"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_image, {
          "preview-teleported": true,
          style: {
            "width": "60px",
            "height": "60px"
          },
          src: data.rowData[0],
          "zoom-rate": 1.2,
          "preview-src-list": data.rowData,
          "initial-index": 4,
          fit: "cover"
        }, null, 8, ["src", "zoom-rate", "preview-src-list"]), _createElementVNode("div", _hoisted_4, [_createElementVNode("span", null, _toDisplayString(data.rowData ? data.rowData.length : 0) + "张", 1)])]),
        _: 2
      }, 1024))]),
      _: 1
    })]),
    _: 1
  })]);
}